module.exports = __webpack_public_path__ + "img/Service3.540f861d.svg";